import { Controller } from "@hotwired/stimulus";
import Tags from "../../shared/tags";

export default class extends Controller {
  connect() {
    this.update();
  }

  update(event) {
    const select = this.element.querySelector(
      'select[name$="[campagne_ids][]"]',
    );
    const checkbox = this.element.querySelector(
      'input[type="checkbox"][name$="[geen_campagne]"]',
    );
    if (!select || !checkbox) return;

    const tags = select._tags || Tags.getInstance(select);
    if (event?.target === checkbox && checkbox.checked) {
      if (tags) {
        tags.removeAll();
      } else {
        Array.from(select.options).forEach((option) => {
          option.selected = false;
        });
      }
    }
    const heeftCampagnes = Array.from(select.selectedOptions).some(
      (option) => option.value !== "",
    );
    const selectUit = checkbox.checked && !heeftCampagnes;
    if (tags) {
      selectUit ? tags.disable() : tags.enable();
    } else {
      select.disabled = selectUit;
    }
    checkbox.disabled = !checkbox.checked && heeftCampagnes;
  }
}
